const constants = {
  PZN_BLOCK_NAME: "helix-common/pzn-container-block",
  PZN_MARKER: "~pzn~",
  PZN_BLOCK_SEPARATOR: "~~",
  ACCESSPOINT_CASID_SEPARATOR: "~",
  PZN_AP_SEPARATOR: "|",
  PZN_AP_OFFERNAME_SEPARATOR: ":",
  PZN_ACTION: "im",
  PZN_WORKFLOW: "marketing"
};

module.exports = { ...constants };
